import React, { useCallback, useContext } from 'react'
import { AuthContext } from '../../../../context/auth/auth-context'
import axios from 'axios'
import { IconButton, Tooltip } from '@mui/material'
import ListAltIcon from '@mui/icons-material/ListAlt'
import { isEmptyString } from '../../../../utils/string-utils'

export interface ViewJSONTriggerProps {
  dataUrl: string | null
}

const ViewJSONTrigger: React.FC<ViewJSONTriggerProps> = (props) => {
  const { dataUrl } = props
  const isDisabled = isEmptyString(dataUrl)

  const { isAuthorized, accessToken } = useContext(AuthContext)

  const getAndDisplayData = useCallback(() => {
    if (isEmptyString(dataUrl) || dataUrl == null) {
      return
    }

    axios
      .get(dataUrl, { headers: { Authorization: `Bearer ${accessToken}` } })
      .then(response => {
        const data = response.data
        const html = `<!DOCTYPE html><html lang='en'><body><pre>${JSON.stringify(data, null, 2)}</pre></body></html>`
        const newTab = window.open('about:blank', '_blank')
        newTab?.document.write(html)
        newTab?.document.close() // finish loading the page
      })
      .catch(error => {
        console.error(error)
      })
  }, [isAuthorized, accessToken, dataUrl])

  return (
    <Tooltip title='View as .json in a new tab'>
      <span>
        <IconButton size='small' disabled={isDisabled} onClick={getAndDisplayData}>
          <ListAltIcon/>
        </IconButton>
      </span>
    </Tooltip>
  )
}

export default React.memo(ViewJSONTrigger)
